import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import axios from 'axios';
import { InvoiceService } from 'frilans-finans';
import { toMoney } from '../../../views/invoice-tool/amount/amount-helper';
import { getVatById } from '../../../views/invoice-tool/invoice-tool-helper';
import { Link } from 'react-router';
import Translate from 'react-translate-component';

import Invoicing from '../../../components/invoice-details/invoicing';
import Specification from '../../../components/invoice-details/specification';
import Dates from '../../../components/invoice-details/dates';
import Amount from '../../../components/invoice-details/amount';
import WorkerAmount from '../../../components/invoice-details/worker-amount';
import Outlays from '../../../components/invoice-details/outlays';

const DEFAULT_CURRENCY_ID = 1;

class ReviewOrderModal extends React.Component {

  static propTypes = {
    close: PropTypes.func,
    invoiceId: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      invoice: null,
      invoiceUser: null,
      outlays: [],
      fetching: true,
      fetchError: false
    };

    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount () {
    this.fetchData();
  }

  fetchData () {
    axios.all([
      InvoiceService.getById(this.props.invoiceId),
      InvoiceService.getSupplierLedgersForInvoice(this.props.invoiceId)
    ])
      .then(axios.spread(this.handleAPIResponse.bind(this)))
      .catch(() => {
        this.setState({
          fetching: false,
          fetchError: true
        });
      });
  }

  handleAPIResponse (invoice, outlays) {
    const invoiceUser = invoice.invoiceUsers.find((invoiceUser) => invoiceUser.userId === +this.props.user.id);
    this.setState({
      invoice: invoice,
      outlays: outlays,
      invoiceUser: invoiceUser,
      fetching: false,
      fetchError: false
    });
  }

  render () {
    if (this.state.invoice && this.state.invoiceUser) {
      const outlaysAmount = this.state.outlays.reduce(
        (previous, current) => previous + toMoney(current.amount * (1 + (getVatById(current.taxId) / 100))), 0
      );

      return (
        <Modal
          className='modal'
          contentLabel=''
          isOpen
          onRequestClose={this.props.close}
        >
          <div className='modal-content'>
            <button className='close' onClick={this.props.close} />
            <div className='invoice-details-container'>
              <Invoicing
                isReviewModal
                description='REVIEW_AND_CREATE_INVOICE_DESCRIPTION'
                title='INVOICE_DETAILS_REVIEW_AND_CREATE_INVOICE'
                invoice={this.state.invoice}
                user={this.props.user}
              />
              <Specification invoice={this.state.invoice} />
              <Dates invoice={this.state.invoice} />
              <Amount invoice={this.state.invoice} />
              <Outlays
                outlays={this.state.outlays}
                showDetailColumns={false}
              />
              <WorkerAmount
                currencyId={DEFAULT_CURRENCY_ID}
                invoice={this.state.invoice}
                user={this.state.invoiceUser}
                outlaysAmount={outlaysAmount}
              />
              <div className='modal-button-container'>
                <Link to={'/invoice-tool/' + this.props.invoiceId} className='btn blue'>
                  <Translate content='REVIEW_AND_CREATE_INVOICE_EDIT_ASSIGNMENT_BUTTON' />
                </Link>
              </div>
            </div>
          </div>
        </Modal>
      );
    }
    return null;
  }

}

export default ReviewOrderModal;



/** WEBPACK FOOTER **
 ** ./src/components/modal/review-order/review-order-modal.js
 **/